import { Injectable } from '@angular/core';
import { ProductsControllerApiService } from '@lx/shared/api/services';
import { DEFAULT_CACHE_TIME, CachedRequestResponse } from '@lx/shared/utils-http';
import { getLocale } from '@lx/shared/i18n';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Language as MotherTongue } from '@lx/language';
import { getCompanyHeader } from '@lx/shared/tokens';

@Injectable({
  providedIn: 'root',
})
export class MotherTongueService {
  private locale = getLocale();
  private internalCache$: Observable<MotherTongue[]>;
  private cacheSettings: any = {
    get: DEFAULT_CACHE_TIME,
  };

  private responseCache = new CachedRequestResponse<MotherTongue[]>(
    () => this.productsApiService.getLanguages(this.locale, this.companyHeader),
    this.cacheSettings.get,
  );

  private readonly companyHeader = getCompanyHeader();

  constructor(private productsApiService: ProductsControllerApiService) {}

  public getAll(): Observable<MotherTongue[]> {
    if (!this.internalCache$) {
      this.internalCache$ = this.responseCache.get();
    }
    return this.internalCache$;
  }

  public getByCode(code: string): Observable<MotherTongue> {
    return this.getAll().pipe(map((language) => language.find((c) => c.code === code)));
  }
}
